import FeatherIcon from 'feather-icons-react';
import { fmtDate, fmtTime } from '../Helpers/format';

const TASK_ICON = {
  'Suite cleaning': 'star',
  'TELUS equipment return': 'tv',
  'Return items to management': 'key',
  'Carpet cleaning (if applicable)': 'wind',
  'Parking inspection': 'navigation',
  'Damage deposit': 'dollar-sign',
  'Elevator booking (2 hours)': 'chevrons-up',
};

const GROUP_ICON = {
  'Cleaning and removal': 'trash-2',
  'Carpet cleaning (steam cleaning)': 'droplet',
  Painting: 'edit-3',
  'Repair or replacement': 'tool',
};

const companyMark = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return null;
  if (parts.length === 1) return <strong className="pm-company-lead">{parts[0]}</strong>;
  return (
    <>
      <strong className="pm-company-lead">{parts.slice(0, -1).join(' ')}</strong>
      <span className="pm-company-tail">{parts[parts.length - 1]}</span>
    </>
  );
};

const TaskIcon = ({ name, size = 15 }) => <span className="pm-task-icon" aria-hidden="true"><FeatherIcon icon={name} size={size} /></span>;

export const ChecklistPreview = ({ data, residentName = '[Resident name]', unit, date, moveoutDate, moveoutTime, note, contact = data.contact }) => {
  const tasks = data.checklist || [];
  const cleaning = data.cleaningChecklist || [];
  const groups = data.chargeGroups || [];
  const company = data.companyName || 'Your property management team';
  const mid = Math.ceil(cleaning.length / 2);
  const helpTitle = data.helpTitle || 'Need help?';
  const helpText = data.helpText || 'If anything is unclear, please reach out to your property team before the visit.';

  return (
    <section className="pm-email-preview pm-checklist-mail" aria-label="Email preview">
      <div className="pm-checklist-mail-grid">
        <div className="pm-checklist-mail-main">
          <header className="pm-checklist-mail-intro">
            <h4>{data.title}</h4>
            <p className="pm-checklist-mail-hello"><FeatherIcon icon="home" size={14} aria-hidden="true" /> Hi {residentName},</p>
          </header>
          <p>{company} is here to help make your move a little easier. {data.introduction}</p>
          <div className="pm-checklist-inspect">
            <div className="pm-checklist-inspect-label">
              <TaskIcon name="calendar" size={16} />
              <div>
                <strong>Pre-moveout inspection</strong>
                <small>{date ? fmtDate(date) : 'Choose an inspection date'}</small>
              </div>
            </div>
            <dl>
              <div><dt>Suite</dt><dd>{unit?.unit_number || '—'}</dd></div>
              <div><dt>Date</dt><dd>{moveoutDate ? fmtDate(moveoutDate) : 'Choose a date'}</dd></div>
              <div><dt>Time</dt><dd>{fmtTime(moveoutTime) || 'Choose a time'}<small>Building local time</small></dd></div>
            </dl>
          </div>
          <h5 className="pm-checklist-section">A few things to take care of before you leave</h5>
          <ol className="pm-responsibilities">
            {tasks.map((item, index) => (
              <li className="responsibility" key={item.title}>
                <span className="pm-task-index" aria-hidden="true">{index + 1}</span>
                <TaskIcon name={item.icon || TASK_ICON[item.title] || 'check-circle'} />
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.text}</p>
                  {item.links?.length > 0 && (
                    <p className="pm-checklist-links">{item.links.map((link) => <a key={link.href} href={link.href}>{link.label}</a>)}</p>
                  )}
                </div>
              </li>
            ))}
            <li className="pm-checklist-help">
              <TaskIcon name="help-circle" />
              <div>
                <strong>{helpTitle}</strong>
                <p>{helpText}</p>
              </div>
            </li>
          </ol>
        </div>
        <div className="pm-checklist-mail-side">
          <h5 className="pm-checklist-section"><TaskIcon name="list" size={14} /> Your suite cleaning checklist</h5>
          <div className="pm-cleaning-split">
            {[cleaning.slice(0, mid), cleaning.slice(mid)].map((column, columnIndex) => (
              <ul className="pm-cleaning-checklist" key={columnIndex}>
                {column.map((item) => <li className="cleaning-item" key={item}>{item}</li>)}
              </ul>
            ))}
          </div>
          <h5 className="pm-checklist-section"><TaskIcon name="dollar-sign" size={14} /> Charges to keep in mind</h5>
          <div className="pm-charges-grid">
            {groups.map((group) => (
              <table className="pm-checklist-charges" key={group.title}>
                <caption>
                  <TaskIcon name={group.icon || GROUP_ICON[group.title] || 'info'} size={14} />
                  {group.title}
                </caption>
                <thead><tr><th scope="col">Item / service</th><th scope="col">Charge</th></tr></thead>
                <tbody>
                  {group.items.map((item) => (
                    <tr key={item.label}>
                      <th scope="row">{item.label}</th>
                      <td>{item.amount}{item.detail && <small>{item.detail}</small>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ))}
          </div>
        </div>
      </div>
      {note && <><h6>A note from your property team</h6><p className="pm-note">{note}</p></>}
      <footer className="pm-checklist-mail-footer">
        <div className="pm-company-mark">{companyMark(data.companyName)}</div>
        <div className="pm-checklist-mail-signoff">
          <p>{data.closing}</p>
          <p>Warm regards,</p>
          <p className="pm-checklist-mail-from"><strong>{contact?.name || 'Your property team'}</strong>{data.companyName ? <> | {data.companyName}</> : null}</p>
          {contact?.phone && <a href={contact.phoneHref || undefined}><FeatherIcon icon="phone" size={14} />{contact.phone}</a>}
          {contact?.email && <a href={`mailto:${contact.email}`}><FeatherIcon icon="mail" size={14} />{contact.email}</a>}
        </div>
        <p className="pm-letter-thanks">Thank you for being a valued resident.</p>
      </footer>
    </section>
  );
};
